import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'models/errors/ApiError';
import { ErrorCode, toErrorCode } from 'models/errors/errorCodes';
import { RootState } from 'store';

export interface GlobalErrorState extends ErrorCode {
  counter: number;
}

export const defaultErrorState: GlobalErrorState = {
  counter: 0,
  messageKey: '',
  type: ''
};

// Export slice
export const globalErrorSlice = createSlice({
  name: 'error',
  initialState: defaultErrorState,
  reducers: {
    displayApiError: (state, action: PayloadAction<ApiError>) => {
      const { messageKey, type } = toErrorCode(action.payload.code);

      state.messageKey = messageKey;
      state.type = type;
      state.counter += 1;
    },
    displayError: (state, action: PayloadAction<string>) => {
      const { messageKey, type } = toErrorCode(action.payload);

      state.messageKey = messageKey;
      state.type = type;
      state.counter += 1;
    }
  }
});

// Export selectors
export const globalErrorSelector = (state: RootState) => state.globalError;

// Export actions
export const { displayError, displayApiError } = globalErrorSlice.actions;

// Export reducers
export const globalErrorReducer = globalErrorSlice.reducer;
